
<ngx-paypal [config]="payPalConfig"></ngx-paypal>



